import React from "react";

import { useProviderManifest } from "src/api/connectApi/queries";
import CustomConnectionIcon from "src/assets/CustomConnectionIcon.svg?react";
import { CustomIcon } from "src/connections/config/CustomIcon";
import { useWorkspaceAndOrg } from "src/utils/useCurrentWorkspace";

type Props = {
  provider: string;
  manifestVersion?: string;
  className?: string;
};

export const ManifestIcon: React.FC<Props> = ({
  provider,
  manifestVersion,
  className,
}) => {
  const workspaceData = useWorkspaceAndOrg();
  const manifest = useProviderManifest(
    workspaceData.workspace?.base_url,
    provider,
    manifestVersion || "latest",
  ).data;

  // Use custom media key icon if available
  const mediaKey = (manifest?.environment_configs?.production?.constants
    ?.media_key ?? null) as string | null;
  if (mediaKey) {
    return <CustomIcon className={className} mediaKey={mediaKey} />;
  }

  // If there's no icon specified in the manifest, default to the CC default one
  if (!manifest?.icon_path) {
    return <CustomConnectionIcon className={className} />;
  }

  return (
    <div className={className}>
      <img
        alt={`${provider} Icon`}
        data-loc={`${provider}-icon`}
        src={manifest.icon_path}
      />
    </div>
  );
};
